// extracted by mini-css-extract-plugin
export default {"main-page":"MainPage_main-page__kncCV","alert-section":"MainPage_alert-section__pyz++"};